import { render, staticRenderFns } from "./pagToolsDialog.vue?vue&type=template&id=2aebb0a2&scoped=true"
import script from "./pagToolsDialog.vue?vue&type=script&lang=js"
export * from "./pagToolsDialog.vue?vue&type=script&lang=js"
import style0 from "./pagToolsDialog.vue?vue&type=style&index=0&id=2aebb0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aebb0a2",
  null
  
)

export default component.exports